import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ProjectsGrid.css';
import { getProjectsData } from '../data/projectsData';

const ProjectsGrid = () => {
  const { t } = useTranslation();
  const projects = useMemo(() => getProjectsData(t), [t]);

  const [mainProject, sideProject, ...otherProjects] = projects;

  return (
    <section className="projects-grid section-padding" id="projects">
      <div className="container">
        <div className="section-header fade-up projects-header">
          <div className="projects-label">{t('projects_section_label')}</div>
          <h2>{t('projects_section_title')}</h2>
        </div>

        <div className="projects-container">
          <div className="projects-main-row">
            {mainProject && (
              <Link
                to={`/projects/${mainProject.slug}`}
                className="project-item project-item-hero fade-up stagger-1"
              >
                <div className="project-image-wrapper">
                  <img src={mainProject.image} alt={mainProject.title} />
                  <div className="project-hero-caption">
                    <span>{mainProject.title}</span>
                  </div>
                </div>
              </Link>
            )}

            {sideProject && (
              <Link
                to={`/projects/${sideProject.slug}`}
                className="project-item project-item-side fade-up stagger-2"
              >
                <div className="project-image-wrapper">
                  <img src={sideProject.image} alt={sideProject.title} />
                  <div className="project-side-caption">
                    <span>{sideProject.title}</span>
                  </div>
                </div>
              </Link>
            )}
          </div>

          {otherProjects.length > 0 && (
            <div className="projects-secondary-row">
              {otherProjects.map((project, index) => (
                <Link
                  key={project.id}
                  to={`/projects/${project.slug}`}
                  className={`project-item project-item-secondary fade-up stagger-${(index % 4) + 1}`}
                >
                  <div className="project-image-wrapper">
                    <img src={project.image} alt={project.title} />
                  </div>
                  <div className="project-info">
                    <h4>{project.title}</h4>
                    <p>{project.category}</p>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProjectsGrid;
